/** Live-verified strings from docs/spec/modules/time-tracker.md (24) and docs/reference/live/tracker-*.md. */
export const s = {
  pageTitle: "Time Tracker",
  timerPlaceholder: "What are you working on?",
  manualPlaceholder: "What have you worked on?",
  start: "START",
  stop: "STOP",
  add: "ADD",
  project: "Project",
  noProject: "No project",
  tags: "Tags",
  billable: "Billable",
  nonBillable: "Non-billable",
  timerMode: "Timer mode",
  manualMode: "Manual mode",
  manualDisabled: "Manual mode disabled.",
  stopToAddManually: "Stop the timer to add time manually",
  today: "Today",
  yesterday: "Yesterday",
  thisWeek: "This week",
  lastWeek: "Last week",
  weekTotal: "Week total:",
  total: "Total:",
  bulkEdit: "Bulk Edit",
  bulkEditIcon: "Bulk edit",
  delete: "Delete",
  split: "Split",
  duplicate: "Duplicate",
  addAsFavorite: "Add as favorite",
  discard: "Discard",
  addDescription: "Add description",
  continueTimer: "Continue timer for this activity",
  entryMenu: "Time entry actions",
  timerMenu: "Timer actions",
  locked: "Locked",
  approved: "Approved",
  searchProject: "Search Project or Client",
  favorites: "FAVORITES",
  noClient: "NO CLIENT",
  projectsCount: (n: number) => `${n} ${n === 1 ? "Project" : "Projects"}`,
  tasksCount: (n: number) => `${n} ${n === 1 ? "Task" : "Tasks"}`,
  createNewProject: "Create new Project",
  noProjects: "No projects",
  tagSearch: "Add/Search tags",
  noTags: "No tags",
  startTime: "Start time",
  endTime: "End time",
  date: "Date",
  durationInput: "Time duration input",
  selectAll: "Select all",
  selectEntry: "Select time entry",
  emptyTitle: "Let's start tracking!",
  emptyText: "Start the timer or add time manually to see your entries here.",
  deleteTitle: "Delete",
  deleteBody: "Are you sure you want to delete this time entry?",
  deleteConfirm: "DELETE",
  cancel: "Cancel",
  save: "SAVE",
  deletedToast: "Time entry has been deleted",
  entriesDeletedToast: (n: number) => `${n} time entries have been deleted`,
  undo: "UNDO",
  discardTitle: "Discard time entry",
  discardBody: "Are you sure you want to discard this time entry?",
  discardConfirm: "DISCARD",
  bulkDeleteTitle: "Delete entries",
  bulkDeleteBody: (n: number) => `Are you sure you want to delete ${n} entries? Type DELETE to confirm.`,
  bulkDeletePlaceholder: "DELETE",
  bulkEditTitle: (n: number) => `Bulk edit ${n} entries`,
  description: "Description",
  descriptionPlaceholder: "Add description...",
  addToExisting: "Add to existing",
  overwriteExisting: "Overwrite existing",
  yes: "Yes",
  time: "Time",
  lockedSkipped: (n: number) => `${n} entries could not be updated because they are locked`,
  splitTitle: "Split",
  splitAt: "Split at:",
  splitTooShort: "Entry is too short to split",
  favoriteName: "Name",
  favoritesMax: "Reached maximum of 5 favorite entries.",
  removeFavoriteTitle: "Remove from favorites",
  removeFavoriteBody: "Are you sure you want to remove this entry from favorites?",
  remove: "Remove",
  keyboardShortcut: (n: number) => `Keyboard shortcut : ${n}`,
  favoriteRunning: "Stop the current timer to start a favorite",
  missingRequired: "Missing required fields",
  fix: "FIX",
  editTitle: "Edit time entry",
  createTitle: "Add time entry",
  timeAndDate: "Time and date",
  addTags: "Add tags",
  loading: "Loading",
  createTask: "Create Task",
  noInternet: "No internet connection. Changes will be saved when you're back online.",
  dash: "-",
  plusDays: (n: number) => `+${n}`,
} as const;
